const defaultExchangeCalculateState = {
  // currency
  currenciesData: [],
  isLoadingCurrencies: false,
  // exchange calculate
  exchangeCalculateRequest: null,
  amountRateData: null,
  isLoadingAmountRate: false,
  onExchangeCalculate: () => {},
  isFirstExchangeCalculation: true,
};

export { defaultExchangeCalculateState };
